/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import StyledTermsCondition from "./StyledTermsCondition";
import { Box } from "@mui/material";
import { fetchPrivacyPolicy } from "../../../store/reducers/authentication/apiThunk";
import { useDispatch } from "react-redux";
import rollbar from "../../../rollbarConfig";

const PrivacyPolicy = () => {
  const dispatch = useDispatch();
  const [htmlContent, setHtmlContent] = useState("");

  const fetchPrivacyPocily = async () => {
    const querry = "?section=seller"
    try {
      const res = await dispatch(fetchPrivacyPolicy(querry));
      setHtmlContent(res?.payload?.data?.[0]?.document);
    } catch (error) {
      rollbar.error("Error message", error);
      console.log("Error fetching terms:", error);
    }
  };

  useEffect(() => {
    fetchPrivacyPocily();
  }, []);

  const contentStyles = `
  .terms-content {
    font-family: 'Lexend', sans-serif;
    color: #333;
    line-height: 1.6;
  }
  .terms-content h1 {
    font-family: 'Lexend', sans-serif;
    font-size: 28px;
    font-weight: 500;
    margin-bottom: 20px;
    color: #000;
  }
  .terms-content h2 {
    font-family: 'Lexend', sans-serif;
    font-size: 24px;
    font-weight: 500;
    margin-top: 30px;
    margin-bottom: 15px;
    color: #000;
  }
  .terms-content h3 {
    font-family: 'Lexend', sans-serif;
    font-size: 20px;
    font-weight: 500;
    margin-top: 25px;
    margin-bottom: 10px;
    color: #000;
  }
  .terms-content p {
    font-family: 'Lexend', sans-serif;
    font-size: 16px;
    margin-bottom: 15px;
  }
  .terms-content ul, .terms-content ol {
    font-family: 'Lexend', sans-serif;
    margin-bottom: 15px;
  }
  .terms-content li {
    font-family: 'Lexend', sans-serif;
    margin-bottom: 8px;
  }
  .terms-content a {
    font-family: 'Lexend', sans-serif;
    color: #0066cc;
    text-decoration: underline;
  }
  .terms-content u, .terms-content strong {
    word-break: break-word;
  }
`;
const wrappedHtmlContent = `
  <style>${contentStyles}</style>
  <div class="terms-content">
    ${htmlContent}
  </div>
`;
  return (
    <StyledTermsCondition>
      <Box
        className="privacy-policy-wrap"
        sx={{
          p: {xs: "30px 23px 200px",
          md: "30px 50px 200px",
          lg: "30px 90px 200px"}
        }}
      >
        {htmlContent ? (
          <Box dangerouslySetInnerHTML={{ __html: wrappedHtmlContent }} />
        ) : (
          <Box className="no-content">No Content Added</Box>
        )}
      </Box>
    </StyledTermsCondition>
  );
};

export default PrivacyPolicy;
